/**
 * Selects the current active session from store.
 */
export default (state) => state.restricted._session.currentSessionId;
